var _g, _g2, _g3, _use, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgComment = function SvgComment(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "1em",
    height: "1em",
    viewBox: "0 0 50 44"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-506 -3164)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Comment_svg__a",
    fill: "currentColor",
    transform: "translate(541.251 3179)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "Comment_svg__b"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Comment_svg__a",
    fill: "currentColor",
    transform: "translate(541.251 3179)"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#Comment_svg__b)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Comment_svg__c",
    fill: "currentColor",
    transform: "translate(541.251 3179)"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-506 -3164)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Comment_svg__a",
    fill: "currentColor",
    transform: "translate(528.81 3179)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "Comment_svg__d"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Comment_svg__a",
    fill: "currentColor",
    transform: "translate(528.81 3179)"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#Comment_svg__d)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Comment_svg__c",
    fill: "currentColor",
    transform: "translate(528.81 3179)"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-506 -3164)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Comment_svg__a",
    fill: "currentColor",
    transform: "translate(516.368 3179)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "Comment_svg__e"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Comment_svg__a",
    fill: "currentColor",
    transform: "translate(516.368 3179)"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#Comment_svg__e)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Comment_svg__c",
    fill: "currentColor",
    transform: "translate(516.368 3179)"
  })))), _use || (_use = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Comment_svg__f",
    fill: "currentColor",
    transform: "translate(1 1)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "Comment_svg__a",
    d: "M6.22 3c0 1.657-1.392 3-3.11 3S0 4.657 0 3s1.393-3 3.11-3c1.718 0 3.11 1.343 3.11 3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Comment_svg__c",
    d: "M4.22 3c0 .485-.428 1-1.11 1v4c2.754 0 5.11-2.171 5.11-5zM3.11 4C2.428 4 2 3.485 2 3h-4C-2 5.829.357 8 3.11 8zM2 3c0-.485.428-1 1.11-1v-4C.357-2-2 .171-2 3zm1.11-1c.682 0 1.11.515 1.11 1h4c0-2.829-2.356-5-5.11-5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Comment_svg__f",
    d: "M12.442 32.455h1a1 1 0 0 0-1-1zm0 9.545h-1a1 1 0 0 0 1.56.829zm14.138-9.545v-1a1 1 0 0 0-.56.17zM1 5a4 4 0 0 1 4-4v-2a6 6 0 0 0-6 6zm0 22.455V5h-2v22.455zm4 4a4 4 0 0 1-4-4h-2a6 6 0 0 0 6 6zm7.442 0H5v2h7.442zm1 10.545v-9.545h-2V42zM26.02 31.626 11.882 41.17l1.12 1.658 14.137-9.546zM43 31.454H26.58v2H43zm4-4a4 4 0 0 1-4 4v2a6 6 0 0 0 6-6zM47 5v22.455h2V5zm-4-4a4 4 0 0 1 4 4h2a6 6 0 0 0-6-6zM5 1h38v-2H5z"
  }))));
};
export default SvgComment;